<template>
<!--<div lang="zh-Hant">-->
       
<!--<body link="blue">-->
<div>       
       <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
 
 <div v-if="$route.params.language === 'en'">

      <div class="col-12 px-0 pt-1 text-center">
        <div class="col-md-6 row mx-0 p-3">
          <button class="col-auto btn btn-primary" style="background-color:#33135cf2; border-radius: 10px; min-width: 50px; " @click="isShow = 'A'">
              <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">KH Controller</div>
              <div class="col-12 px-0 py-1 font-weight-bold"><img style="width: 50px;" src="../assets/KHA.png"> KHA</div>  
          </button>&nbsp;
          <button class="col-auto btn btn-primary" style="background-color:#33135cf2; border-radius: 10px; min-width: 50px;" @click="isShow = 'B'">
              <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">CaRx</div>
              <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">Controller</div>
              <div class="col-12 px-0 py-1 font-weight-bold" style="font-size:1rem"><img style="width: 50px;" src="../assets/CRA.png"> CRA</div>
          </button>
        </div>			
      </div>
       
      <div v-if="isShow == 'A'">
          <div class="col-12 px-0 pt-0"> 
            <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA install_EN_ppt.pptx" 
                  width="357px" height="600px" frameborder="0" style="width:100%"></iframe>
            <div class="col-auto mt-4 mb-0 font-weight-bold" style="font-size:1.2rem"><a  href="https://v.douyin.com/i8P44fow/">Video of quick start installation (Click & Open a new windows)</a>
                  <p>Please check the manual below for detail settings</p>
            </div>
            <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA install_EN_doc.docx?page=hsn#toolbar=0" 
                  style="width:100%; height:40000px; frameborder:0; overflow-y:scroll; scrolling:no;"></iframe> 
          </div>
       </div>
       <div v-if="isShow == 'B'">
          <div class="col-12 px-0 pt-0"> 
              <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA install_EN_ppt.pptx" 
               width="357px" height="600px" frameborder="0" style="width:100%"></iframe>
              <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA install_EN_doc.docx?page=hsn#toolbar=0" 
               style="width:100%; height:40000px; frameborder:0; overflow-y:scroll; scrolling:no;" ></iframe> 
          </div>
       </div>
         
  </div>

  <div v-if="$route.params.language === 'vi'">

    <div class="col-12 px-0 pt-1 text-center">
      <div class="col-md-6 row mx-0 p-3">
        <button class="col-auto btn btn-primary" style="background-color:#33135cf2; border-radius: 10px; min-width: 50px; " @click="isShow = 'A'">
            <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">KH Controller</div>
            <div class="col-12 px-0 py-1 font-weight-bold"><img style="width: 50px;" src="../assets/KHA.png"> KHA</div>  
        </button>&nbsp;
        <button class="col-auto btn btn-primary" style="background-color:#33135cf2; border-radius: 10px; min-width: 50px;" @click="isShow = 'B'">
            <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">CaRx</div>
            <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">Controller</div>
            <div class="col-12 px-0 py-1 font-weight-bold" style="font-size:1rem"><img style="width: 50px;" src="../assets/CRA.png"> CRA</div>
        </button>
      </div>			
    </div>
    
    <div v-if="isShow == 'A'">
          <div class="col-12 px-0 pt-0"> 
            <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA install_VN_ppt.pptx" 
                  width="357px" height="600px" frameborder="0" style="width:100%"></iframe>
            <div class="col-auto mt-4 mb-0 font-weight-bold" style="font-size:1.2rem"><a  href="https://v.douyin.com/i8P44fow/">Video hướng dẫn cài đặt nhanh chóng (Nhấp và Mở cửa sổ mới)</a>
                  <p>Vui lòng kiểm tra hướng dẫn bên dưới để biết cài đặt chi tiết</p>
            </div>
            <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA install_VN_doc.docx?page=hsn#toolbar=0" 
                  style="width:100%; height:40000px; frameborder:0; overflow-y:scroll; scrolling:no;"></iframe> 
          </div>
       </div>
       <div v-if="isShow == 'B'">
          <div class="col-12 px-0 pt-0"> 
              <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA install_CN_ppt.pptx" 
               width="357px" height="600px" frameborder="0" style="width:100%"></iframe>
              <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA install_CN_doc.docx?page=hsn#toolbar=0" 
               style="width:100%; height:40000px; frameborder:0; overflow-y:scroll; scrolling:no;" ></iframe> 
          </div>
       </div>
   
</div>

<div v-if="$route.params.language === 'ms'">

<div class="col-12 px-0 pt-1 text-center">
  <div class="col-md-6 row mx-0 p-3">
    <button class="col-auto btn btn-primary" style="background-color:#33135cf2; border-radius: 10px; min-width: 50px; " @click="isShow = 'A'">
        <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">KH Controller</div>
        <div class="col-12 px-0 py-1 font-weight-bold"><img style="width: 50px;" src="../assets/KHA.png"> KHA</div>  
    </button>&nbsp;
    <button class="col-auto btn btn-primary" style="background-color:#33135cf2; border-radius: 10px; min-width: 50px;" @click="isShow = 'B'">
        <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">CaRx</div>
        <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">Controller</div>
        <div class="col-12 px-0 py-1 font-weight-bold" style="font-size:1rem"><img style="width: 50px;" src="../assets/CRA.png"> CRA</div>
    </button>
  </div>			
</div>
 
<div v-if="isShow == 'A'">
          <div class="col-12 px-0 pt-0"> 
            <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA install_MA_ppt.pptx" 
                  width="357px" height="600px" frameborder="0" style="width:100%"></iframe>
            <div class="col-auto mt-4 mb-0 font-weight-bold" style="font-size:1.2rem"><a  href="https://v.douyin.com/i8P44fow/">Video of quick start installation (Click & Open a new windows)</a>
                  <p>Please check the manual below for detail settings</p>
            </div>
            <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA install_MA_doc.docx?page=hsn#toolbar=0" 
                  style="width:100%; height:40000px; frameborder:0; overflow-y:scroll; scrolling:no;"></iframe> 
          </div>
       </div>
       <div v-if="isShow == 'B'">
          <div class="col-12 px-0 pt-0"> 
              <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA install_CN_ppt.pptx" 
               width="357px" height="600px" frameborder="0" style="width:100%"></iframe>
              <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA install_CN_doc.docx?page=hsn#toolbar=0" 
               style="width:100%; height:40000px; frameborder:0; overflow-y:scroll; scrolling:no;" ></iframe> 
          </div>
       </div>
   
</div>

  <div v-else-if="$route.params.language === 'cn'" lang="zh-Hans">
      <div class="col-12 px-0 pt-1">
        <div class="col-md-6 row mx-0 p-3 text-center">
          <button class="col-auto btn btn-primary" style="background-color:#33135cf2; border-radius: 10px; min-width: 50px; " @click="isShow = 'A'">
              <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">KH控制器</div>
              <div class="col-12 px-0 py-1 font-weight-bold"><img style="width: 50px;" src="../assets/KHA.png"> KHA</div>  
          </button>&nbsp;
          <button class="col-auto btn btn-primary" style="background-color:#33135cf2; border-radius: 10px; min-width: 50px;" @click="isShow = 'B'">
              <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">鈣反控制器</div>
              <div class="col-12 px-0 py-2 font-weight-bold" style="font-size:1rem"><img style="width: 50px;" src="../assets/CRA.png"> CRA</div>
          </button>
        </div>			
      </div>   
       
       <div v-if="isShow == 'A'">
          <div class="col-12 px-0 pt-0"> 
            <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA install_CN_ppt.pptx" 
                  width="357px" height="600px" frameborder="0" style="width:100%"></iframe>
            <div class="col-auto mt-4 mb-0 font-weight-bold" style="font-size:1.2rem"><a  href="https://v.douyin.com/i8P44fow/">请先看快速安装影片(点击开新视窗)</a>
                  <p>详细说明及各项设定请参考以下说明书</p>
            </div>
            <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA install_CN_doc.docx?page=hsn#toolbar=0" 
                  style="width:100%; height:45000px; frameborder:0; overflow-y:scroll; scrolling:no;"></iframe> 
          </div>
       </div>
       <div v-if="isShow == 'B'">
          <div class="col-12 px-0 pt-0"> 
              <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA install_CN_ppt.pptx" 
               width="357px" height="600px" frameborder="0" style="width:100%"></iframe>
              <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA install_CN_doc.docx?page=hsn#toolbar=0" 
               style="width:100%; height:40000px; frameborder:0; overflow-y:scroll; scrolling:no;" ></iframe> 
          </div>
       </div>
      

  </div>

  <div v-else-if="$route.params.language === 'tw'" lang="zh-Hant">
      <div class="col-12 px-0 pt-1">
        <div class="col-md-6 row mx-0 p-3 text-center">
          <button class="col-auto btn btn-primary" style="background-color:#33135cf2; border-radius: 10px; min-width: 50px; " @click="isShow = 'A'">
              <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">KH控制器</div>
              <div class="col-12 px-0 py-1 font-weight-bold"><img style="width: 50px;" src="../assets/KHA.png"> KHA</div>  
          </button>&nbsp;
          <button class="col-auto btn btn-primary" style="background-color:#33135cf2; border-radius: 10px; min-width: 50px;" @click="isShow = 'B'">
              <div class="col-12 px-0 text-center font-weight-bold" style="font-size:1rem">鈣反控制器</div>
              <div class="col-12 px-0 py-2 font-weight-bold" style="font-size:1rem"><img style="width: 50px;" src="../assets/CRA.png"> CRA</div>
          </button>
        </div>			
      </div>   
       
      <div v-if="isShow == 'A'">
          <div class="col-12 px-0 pt-0"> 
            <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA install_TW_ppt.pptx" 
                  width="357px" height="600px" frameborder="0" style="width:100%"></iframe>
            <div class="col-auto mt-4 mb-0 font-weight-bold" style="font-size:1.2rem"><a  href="https://v.douyin.com/i8P44fow/">請先看快速安裝影片(點擊開新視窗)</a>
                  <p>詳細說明及各項設定請參考以下說明書</p>
            </div>
            <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA install_TW_doc.docx?page=hsn#toolbar=0" 
                  style="width:100%; height:50000px; frameborder:0; overflow-y:scroll; scrolling:no;"></iframe> 
          </div>
       </div>
       <div v-if="isShow == 'B'">
          <div class="col-12 px-0 pt-0"> 
              <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA install_TW_ppt.pptx" 
               width="357px" height="600px" frameborder="0" style="width:100%"></iframe>
              <iframe  src="https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA install_TW_doc.docx?page=hsn#toolbar=0" 
               style="width:100%; height:40000px; frameborder:0; overflow-y:scroll; scrolling:no;" ></iframe> 
          </div>
       </div>


 </div>
</div>
</template>
<script>
export default {
  data: () => {
    return {
      isShow: "A"     // default display KHA installation

      
    }
  }
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// Home.vue?00d0436b